<template>
  <bita-modal
    id="drivers-modal"
    title="رانندگان"
    :modal-lg="true"
    :isLoading="isLoadingModal"
    @close="onCloseModal"
  >
    <div slot="body">
      <table class="table" v-if="showGrid">
        <thead>
          <tr class="text-center">
            <th>#</th>
            <th> راننده </th>
            <th> شماره هوشمند ماشین </th>
            <th> شماره پلاک خودرو </th>
            <th> کدملی </th>
            <th> شماره موبایل </th>
            <th> تاریخ ایجاد </th> 
          </tr>
        </thead>
        <tbody>
          <tr v-for="(driver, index) in drivers" :key="index" class="text-center">
            <td> {{ index+1 }} </td>
            <td>{{ driver.name }}</td>
            <td>{{ driver.car_smartnumber }}</td>
            <td>{{ driver.number_plate }}</td>
            <td>{{ driver.user.national_code }}</td>
            <td>{{ driver.user.phone }}</td>
            <td>{{ $getJalaliDateTime(driver.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </bita-modal>
</template>
<script>
export default {
  data() {
    return {
      isLoadingModal: false,
      showGrid: false,
      driver: {},
      drivers: [],
    };
  },

  methods: {
    setInitialData(_driver) {
      this.showGrid = true;
      this.driver = _driver;
      this.readData();
    },

    readData(e) {

      this.isLoadingModal = true;
      let baseUrl = `vehicles/${this.driver.number_plate}`,
      url = this.$makeQueryString(baseUrl);

      this.$persistClient("get", url)
        .then((res) => {
          this.drivers = res.data.data;
        })
        .catch(() => (this.drivers = []))
        .finally(() => (this.isLoadingModal = false));
    },

    loadData() {
      this.$refs.logGrid.loadDataSource();
    },

    onCloseModal() {
      this.showGrid = false;
      this.drivers = [];
    },
  },
};
</script>